"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTreeViewOptionalPlugins = void 0;
const useTreeViewOptionalPlugins = ({
  plugins
}) => {
  const pluginSet = new Set(plugins);
  const getAvailablePlugins = () => pluginSet;
  return {
    instance: {
      getAvailablePlugins
    }
  };
};
exports.useTreeViewOptionalPlugins = useTreeViewOptionalPlugins;
useTreeViewOptionalPlugins.params = {};